import { Stack } from 'component-library';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { isNullish } from '@/utils/booleans';

import { NoPlotData } from '../NoPlotData';
import { HabitatConnectivityDisplay } from './HabitatConnectivityDisplay';

export const HabitatConnectivityGraphTile = ({
  latestAnalysisFact,
  benchmarks,
}: {
  latestAnalysisFact: PlotReportFactElement<number | null> | undefined;
  benchmarks: number[];
}) => {
  if (!latestAnalysisFact || isNullish(latestAnalysisFact.value)) {
    return <NoPlotData />;
  }

  return (
    <Stack data-testid='habitat-connectivity-graph-tile' className='py-6 w-full h-full' center>
      <HabitatConnectivityDisplay latestAnalysisFact={latestAnalysisFact} benchmarks={benchmarks} />
    </Stack>
  );
};
